import { authTestIds } from "@/lib/data-test-ids/components.data-test-ids";
import { cn } from "@/lib/utils";

interface LastUsedIndicatorProps {
  className?: string;
}

export default function LastUsedIndicator({
  className,
}: LastUsedIndicatorProps) {
  return (
    <>
      <span className="sr-only">Last used sign-in method.</span>
      <div
        data-testid={authTestIds.LAST_USED_INDICATOR}
        aria-hidden="true"
        className={cn(
          "absolute -top-2 right-3 rounded px-1.5 py-0.5 bg-ink-emphasis text-primary-foreground text-[10px] font-medium uppercase tracking-wider text-center",
          className,
        )}
      >
        Last used
      </div>
    </>
  );
}
